import { createGenericReducer } from "common/genericReducer";
import { combineReducers } from "redux";
import {
  ARTICLE_GROUPS_RECEIVED,
  ARTICLE_GROUPS_REQUESTED,
  ARTICLE_GROUPS_REQUEST_FAILED,
  CUTOFF_CAMPAIGN_RECEIVED,
  CUTOFF_CAMPAIGN_REQUESTED,
  CUTOFF_CAMPAIGN_REQUEST_FAILED
} from "./cutoffActions";

const createArticleGroupsReducer = () => {
  return createGenericReducer(ARTICLE_GROUPS_REQUESTED, ARTICLE_GROUPS_RECEIVED, ARTICLE_GROUPS_REQUEST_FAILED);
};

const createCutoffCampaignReducer = () => {
  return createGenericReducer(CUTOFF_CAMPAIGN_REQUESTED, CUTOFF_CAMPAIGN_RECEIVED, CUTOFF_CAMPAIGN_REQUEST_FAILED);
};

export const cutoff = combineReducers({
  articleGroups: createArticleGroupsReducer(),
  cutoffCampaign: createCutoffCampaignReducer()
});
